{
  "header": {
    "welcomeMessage": "Willkommen, {{firstName}}!",
    "description": "Überprüfen und analysieren Sie frühere Feedback-Antworten"
  },
  "emptyState": {
    "company": {
      "title": "Noch keine Daten gesammelt",
      "description": "Deine Reise beginnt hier! Sobald Mitarbeiter im ersten Monat Feedback geben, wirst du Erkenntnisse und Trends sehen"
    },
    "directReports": {
      "title": "Keine direkten Mitarbeitenden",
      "description": "Du hast keine direkten Mitarbeitenden zugewiesen, aber du kannst trotzdem an Umfragen teilnehmen und wertvolles Feedback geben!",
      "bottomAction": {
        "label": "Wenn du denkst, dass das ein Fehler ist, kontaktiere deine Führungskraft",
        "helpText": "Hilfetext"
      }
    }
  },
  "tabs": {
    "company": "Gesamtes Unternehmen",
    "allReports": "Alle Berichte",
    "directReports": "Direkte Berichte",
    "myTeam": "Mein Team"
  },
  "keysInsights": {
    "title": "Wichtige Erkenntnisse",
    "strengths": {
      "title": "Stärken",
      "tooltipTitle": "Hilfetext"
    },
    "growthAreas": {
      "title": "Wachstumsbereiche",
      "tooltipTitle": "Hilfetext"
    }
  },
  "enps": {
    "title": "eNPS",
    "chart": {
      "description": "Der eNPS misst, wie wahrscheinlich es ist, dass Mitarbeiter ihren Arbeitsplatz empfehlen, was das allgemeine Engagement und die Zufriedenheit widerspiegelt"
    },
    "scoreTitle": "Ihr Team",
    "companyAverageTitle": "Unternehmens-eNPS"
  },
  "overview": {
    "title": "Übersicht",
    "scoreTitle": "Ihr Team",
    "companyAverageTitle": "Unternehmensdurchschnitt"
  }
}
